var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntDesignProductOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79688 2.10942C6.92632 2.10942 7.03125 2.21435 7.03125 2.3438V6.79692C7.03125 6.92636 6.92632 7.0313 6.79688 7.0313H2.34375C2.2143 7.0313 2.10938 6.92636 2.10938 6.79692V2.3438C2.10938 2.21435 2.2143 2.10942 2.34375 2.10942H6.79688ZM6.03516 3.10552H3.10547V6.03521H6.03516V3.10552ZM13.2617 4.38998C13.3532 4.4815 13.3532 4.62991 13.2617 4.72143L10.6101 7.37309C10.5185 7.46461 10.3701 7.46461 10.2786 7.37309L7.62696 4.72143C7.53543 4.62991 7.53543 4.4815 7.62696 4.38998L10.2786 1.73832C10.3701 1.6468 10.5185 1.6468 10.6101 1.73832L13.2617 4.38998ZM12.0188 4.5557L10.4443 2.9813L8.86992 4.55571L10.4443 6.13013L12.0188 4.5557ZM6.79688 7.9688C6.92632 7.9688 7.03125 8.07374 7.03125 8.20317V12.6563C7.03125 12.7857 6.92632 12.8907 6.79688 12.8907H2.34375C2.2143 12.8907 2.10938 12.7857 2.10938 12.6563V8.20317C2.10938 8.07374 2.2143 7.9688 2.34375 7.9688H6.79688ZM6.03516 8.96489H3.10547V11.8946H6.03516V8.96489ZM12.6563 7.9688C12.7857 7.9688 12.8906 8.07374 12.8906 8.20317V12.6563C12.8906 12.7857 12.7857 12.8907 12.6563 12.8907H8.20313C8.07368 12.8907 7.96875 12.7857 7.96875 12.6563V8.20317C7.96875 8.07374 8.07368 7.9688 8.20313 7.9688H12.6563ZM11.8945 8.96489H8.96484V11.8946H11.8945V8.96489Z",
    fill: "#970A02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignProductOutlined);
export default __webpack_public_path__ + "static/media/ant-design_product-outlined.19b75152bfe81dcd882a8fd77fa1f630.svg";
export { ForwardRef as ReactComponent };